export const isSnapshotMode = new URLSearchParams(window.location.search).has(
  "__snapshot",
);
